import { Injectable, NgZone } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { grpc } from '@improbable-eng/grpc-web';

import {
  MessagingSettingsGetRoleMessagingRequest,
  MessagingSettingsGetRoleMessagingResponse,
  MessagingSettingsSetRoleMessagingRequest,
  MessagingSettingsSetRoleMessagingResponse,
} from '../messaging_settings/messaging_settings_pb';

import {
  MessagingSettings as __MessagingSettings,
} from '../messaging_settings/messaging_settings_pb_service';

@Injectable({providedIn: 'root'})
export class MessagingSettings {

  constructor(private _ngZone: NgZone) {
  }

  /**
    / Set the role messaging settings for the current Minga
  */
  setRoleMessaging(request: MessagingSettingsSetRoleMessagingRequest): Promise<MessagingSettingsSetRoleMessagingResponse>;
  /**
    / Set the role messaging settings for the current Minga
  */
  setRoleMessaging(request: MessagingSettingsSetRoleMessagingRequest, metadata: grpc.Metadata): Promise<MessagingSettingsSetRoleMessagingResponse>;
  /**
    / Set the role messaging settings for the current Minga
  */
  setRoleMessaging(request: MessagingSettingsSetRoleMessagingRequest, callback: (err: any|null, response: MessagingSettingsSetRoleMessagingResponse, metadata: grpc.Metadata) => void): void;
  /**
    / Set the role messaging settings for the current Minga
  */
  setRoleMessaging(request: MessagingSettingsSetRoleMessagingRequest, metadata: grpc.Metadata, callback: (err: any|null, response: MessagingSettingsSetRoleMessagingResponse, metadata: grpc.Metadata) => void): void;

  setRoleMessaging(request: MessagingSettingsSetRoleMessagingRequest, arg1?: grpc.Metadata|((err: any|null, response: MessagingSettingsSetRoleMessagingResponse, metadata: grpc.Metadata) => void), arg2?: (err: any|null, response: MessagingSettingsSetRoleMessagingResponse, metadata: grpc.Metadata) => void): Promise<MessagingSettingsSetRoleMessagingResponse>|void {
    let ret: any;
    let callback: any;
    let metadata: any;

    if(typeof arg1 === 'function') {
      callback = arg1;
    } else {
      metadata = arg1;
      callback = arg2;
    }

    if(!callback) {
      ret = new Promise<MessagingSettingsSetRoleMessagingResponse>((resolve, reject) => {
        callback = (err: any, response: any) => {
          if(err) reject(err);
          else resolve(response);
        };
      });
    }

    let responseMetadata: grpc.Metadata|null = null;

    let req = grpc.invoke(__MessagingSettings.SetRoleMessaging, {
      request: request,
      host: (<any>window).DEFAULT_ANGULAR_GRPC_HOST || 'https://' + location.hostname,
      metadata: metadata,
      onHeaders: headers => responseMetadata = headers,
      onMessage: response => this._ngZone.run(() => {
        callback(null, response, responseMetadata || new grpc.Metadata());
      }),
      onEnd: (code, msg, metadata) => this._ngZone.run(() => {
        if(code != grpc.Code.OK) {
          let err = new Error(msg);
          (<any>err).code = code;
          callback(err);
        }
      })
    });

    (<any>ret).cancel = () => req.close();
    return ret;
  }

  getRoleMessaging(request: MessagingSettingsGetRoleMessagingRequest): Promise<MessagingSettingsGetRoleMessagingResponse>;
  getRoleMessaging(request: MessagingSettingsGetRoleMessagingRequest, metadata: grpc.Metadata): Promise<MessagingSettingsGetRoleMessagingResponse>;
  getRoleMessaging(request: MessagingSettingsGetRoleMessagingRequest, callback: (err: any|null, response: MessagingSettingsGetRoleMessagingResponse, metadata: grpc.Metadata) => void): void;
  getRoleMessaging(request: MessagingSettingsGetRoleMessagingRequest, metadata: grpc.Metadata, callback: (err: any|null, response: MessagingSettingsGetRoleMessagingResponse, metadata: grpc.Metadata) => void): void;

  getRoleMessaging(request: MessagingSettingsGetRoleMessagingRequest, arg1?: grpc.Metadata|((err: any|null, response: MessagingSettingsGetRoleMessagingResponse, metadata: grpc.Metadata) => void), arg2?: (err: any|null, response: MessagingSettingsGetRoleMessagingResponse, metadata: grpc.Metadata) => void): Promise<MessagingSettingsGetRoleMessagingResponse>|void {
    let ret: any;
    let callback: any;
    let metadata: any;

    if(typeof arg1 === 'function') {
      callback = arg1;
    } else {
      metadata = arg1;
      callback = arg2;
    }

    if(!callback) {
      ret = new Promise<MessagingSettingsGetRoleMessagingResponse>((resolve, reject) => {
        callback = (err: any, response: any) => {
          if(err) reject(err);
          else resolve(response);
        };
      });
    }

    let responseMetadata: grpc.Metadata|null = null;

    let req = grpc.invoke(__MessagingSettings.GetRoleMessaging, {
      request: request,
      host: (<any>window).DEFAULT_ANGULAR_GRPC_HOST || 'https://' + location.hostname,
      metadata: metadata,
      onHeaders: headers => responseMetadata = headers,
      onMessage: response => this._ngZone.run(() => {
        callback(null, response, responseMetadata || new grpc.Metadata());
      }),
      onEnd: (code, msg, metadata) => this._ngZone.run(() => {
        if(code != grpc.Code.OK) {
          let err = new Error(msg);
          (<any>err).code = code;
          callback(err);
        }
      })
    });

    (<any>ret).cancel = () => req.close();
    return ret;
  }

}

